import React from 'react';

import { Box, Button } from '@mui/material';

import useToggleState from '~/hooks/useToggleState';

// a country group with no tail deals can fail for every identifier, so keep the list scannable until asked
const COLLAPSED_ERROR_COUNT = 8;

interface Props {
  errors: Array<string>;
}

function HeroPlannerDebugErrorList({ errors }: Props) {
  const { isToggled: isExpanded, toggle } = useToggleState(false);
  const visibleErrors = isExpanded ? errors : errors.slice(0, COLLAPSED_ERROR_COUNT);

  return (
    <>
      <Box component="ul" m={0} pl={2} sx={{ wordBreak: 'break-word' }}>
        {visibleErrors.map((error, index) => (
          // errors are free text and can repeat, so the position is the only stable key

          <li key={index}>{error}</li>
        ))}
      </Box>
      {errors.length > COLLAPSED_ERROR_COUNT && (
        <Button size="small" color="inherit" onClick={toggle} sx={{ mt: 0.5 }}>
          {isExpanded ? 'Show fewer' : `Show all ${errors.length}`}
        </Button>
      )}
    </>
  );
}

export default HeroPlannerDebugErrorList;
